import atomIconDisable from "@/assets/icons/ic-brain.svg";
import atomIcon from "@/assets/icons/ic-brain-white.svg";

interface RfpGenerateButtonProps {
  disabled: boolean;
  onClick: () => void;
}

export function RfpGenerateButton({ disabled, onClick }: RfpGenerateButtonProps) {
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={onClick}
      className={`flex h-12 items-center justify-center rounded-[4px] gap-2  text-base font-bold leading-6 tracking-[-0.01em] ${
        disabled
          ? "bg-[#EBEBEB] text-[#B0B0B0]"
          : "bg-[#FFAA72] text-black"
      }`}
      style={{ padding: "18.5px 20px 18.5px 16px" }}
    >
      AX readiness 확인하러 가기
    </button>
  );
}
